import { render, staticRenderFns } from "./bf-offer.vue?vue&type=template&id=8d5a74a0&scoped=true&lang=pug&"
import script from "./bf-offer.vue?vue&type=script&lang=js&"
export * from "./bf-offer.vue?vue&type=script&lang=js&"
import style0 from "./bf-offer.vue?vue&type=style&index=0&id=8d5a74a0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5a74a0",
  null
  
)

export default component.exports